import React from 'react'

import { placesClient } from '../../../../utils/apollo/api'
import { usePlaceType } from '../../_context/PlaceTypeContext'
import CleanFilterButton from '../../../../components/filter/CleanFilterButton'
import FlexGrid, { FlexColumn } from '../../../../components/structure/FlexGrid'
import ListCounter from '../../../../components/helpers/ListCounter'
import SeparatorWrapper from '../../../../components/helpers/SeparatorWrapper'

const UsersCounterBar = () => {
  const type = usePlaceType()

  return (
    <SeparatorWrapper weight={4}>
      <FlexGrid justify="flex-start">
        <FlexColumn flex={1}>
          <ListCounter
            client={placesClient}
            entity="places"
            filterName="PlaceFilter"
            filters={{ types: [type] }}
            fullText
            bold
          />
        </FlexColumn>
        <FlexColumn>
          <CleanFilterButton />
        </FlexColumn>
      </FlexGrid>
    </SeparatorWrapper>
  )
}

export default UsersCounterBar
